  <div class="config-dialog">
    <div class="config-header">
    <h2 mat-dialog-title>{{ 'ALDEN.DIALOGS.CONFIG.TITLE' | translate }}</h2>
    <button mat-raised-button mat-dialog-close class="square-button" color="warn">
        <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <mat-tab-group>
        <mat-tab label="{{'ALDEN.DIALOGS.SAVE_SEARCH.TITLE' | translate}}">
            <div class="search-title-container">
                <mat-form-field style="width: 100%;" appearance="standard">
                <mat-label>{{ 'ALDEN.DIALOGS.SAVE_SEARCH.SEARCH_TITLE' | translate }}</mat-label>
                <input matInput [(ngModel)]="title">
                </mat-form-field>
                <button class="square-button" mat-icon-button type="button" aria-label="'ALDEN.DIALOGS.SAVE_SEARCH.SAVE'" (click)="saveSearch()" [disabled] = "title.length == 0" [matTooltip]="'ALDEN.DIALOGS.SAVE_SEARCH.SAVE' | translate"><mat-icon>save</mat-icon></button>
            </div>

            <h3>{{ 'ALDEN.DIALOGS.SAVE_SEARCH.SAVED_SEARCHS.TITLE' | translate }}</h3>
            <mat-list class="save-search-list" *ngIf="files.length > 0">
                <mat-list-item class="save-search-option-row"
                *ngFor="let file of files">
                <div class="file-row">
                    <span class="file-name">
                    {{ file.value }}
                    </span>
                    <div>
                    <button mat-icon-button color="primary" type="button" aria-label="'ALDEN.DIALOGS.SAVE_SEARCH.LOAD'" (click)="loadSearch(file, $event)" [matTooltip]="'ALDEN.DIALOGS.SAVE_SEARCH.LOAD' | translate"><mat-icon>file_upload</mat-icon></button>
                    <button mat-icon-button class="gold-icon" type="button" aria-label="'ALDEN.DIALOGS.SAVE_SEARCH.MARK_AS_DEFAULT'" (click)="toggleDefaultSearch(file, $event)" [matTooltip]="'ALDEN.DIALOGS.SAVE_SEARCH.MARK_AS_DEFAULT' | translate">
                        <mat-icon *ngIf="defaultSearchId != file.key">star_border</mat-icon>
                        <mat-icon *ngIf="defaultSearchId == file.key">star</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" type="button" aria-label="'ALDEN.DIALOGS.SAVE_SEARCH.DELETE'" (click)="deleteFile(file, $event)" [matTooltip]="'ALDEN.DIALOGS.SAVE_SEARCH.DELETE' | translate"><mat-icon>delete</mat-icon></button>
                    </div>
                </div>
                </mat-list-item>
            </mat-list>

            <ng-container *ngIf="files.length == 0">
                <p> {{ 'ALDEN.DIALOGS.SAVE_SEARCH.SAVED_SEARCHS.NO_RESULTS' | translate }} </p>
            </ng-container>
        </mat-tab>
        <mat-tab label="{{'ALDEN.DIALOGS.SAVE_VIEWER_CONFIG.TITLE' | translate}}">
            <div class="current-config">
                <div class="config-title">
                    {{'ALDEN.DIALOGS.SAVE_VIEWER_CONFIG.CURRENT' | translate}}
                </div>
                <div cdkDropList class="dragAndDrop-list" (cdkDropListDropped)="dropColumn($event)">
                    <ng-container *ngFor="let column of columns; let i = index" >
                    <div class="dragAndDrop-box" 
                    *ngIf="column.key !== 'actions' && !column.onlyFilter" 
                    cdkDrag 
                    [cdkDragData]="column" 
                    (cdkDragStarted)="dragStarted()" 
                    (cdkDragEnded)="dragEnded()"  
                    [class.drag-hidden]="isDragging">
                        <div class="draggable-area">
                        <mat-icon class="column-config-drag-handle">drag_handle</mat-icon>
                        <span class="column-config-title">{{ column.title | translate }}</span>
                        </div>
                        <mat-icon class="column-visibility-icon" (click)="toggleIsHidden(column)">
                            {{ column.isHidden ? 'visibility_off' : 'visibility' }}
                        </mat-icon>
                        <ng-template cdkDragPreview>
                        </ng-template>
                    </div>
                    </ng-container>
                </div>
            </div>
            <div class="save-config-columns-actions">
                <button mat-raised-button color="accent" class="delete-button" (click)="deleteConfiguration()">
                    <mat-icon color="warn">refresh</mat-icon>
                    {{'ALDEN.DIALOGS.SAVE_VIEWER_CONFIG.DELETE' | translate}}
                </button>

                <button mat-raised-button color="primary" class="save-button" (click)="saveConfiguration()">
                    <mat-icon>save</mat-icon>
                    {{'ALDEN.DIALOGS.SAVE_VIEWER_CONFIG.SAVE' | translate}}
                </button>
            </div>
        </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>
  </div>